<div class="container my-3 p-3 General container-fluid" style="position: relative;">
  <h3>{{currentYear}} Trending Factors</h3>
  <div class="btn-group trend-button " dropdown>
    <button id="button-Year" dropdownToggle type="button" class="btn btn-secondary"
            aria-controls="dropdown-basic">
      Change Year <span><i class="fas fa-angle-down"></i></span>
    </button>
    <ul id="dropdown-trends" *dropdownMenu class="dropdown-menu"
        role="menu" aria-labelledby="button-basic">
      <div *ngFor="let item of years">
        <li role="menuitem"><a (click)="getTrendFactors(item.year)" class="dropdown-item">{{item.year}}</a></li>
        <li class="divider dropdown-divider"></li>
      </div>
    </ul>
  </div>
  <div class="list-group" *ngFor="let item of trends">
    <app-pdf-url-row>
      <a href="{{item.trendfactorUrl}}" target="_blank">
        <h5 style="padding-top: 2rem">{{item.trendfactorName}}</h5>
      </a>
    </app-pdf-url-row>
  </div>
</div>
